<script setup>
    import { ref, computed, onMounted, getCurrentInstance } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import {usePageLoadingStore} from "../../../../../stores/pageLoading";
    import SNBAdmin from '../../../../../layouts/nav/SNBAdmin.vue'
    import fileService from "../../../../../services/fileService";
    import insightsNewsletterService from "../../../../user/services/insights/insightsNewsletterService";
    import _ from 'lodash'
    import { useAlertStore } from '../../../../../stores/alertStore';
    const { $number } = getCurrentInstance().appContext.config.globalProperties;
    const { $alert } = useAlertStore();
    
    const route = useRoute()
    const router = useRouter()
    const loadingStore = usePageLoadingStore()

    onMounted(()=>{
        const { id } = route.params;
        if(!id) {
            goBack()
        } else {
            retrieveNewsletterDetail(id)
        }
    })

    const newsletterDetail = ref({})
    const input = ref({
        title: '',
        content: '',
        newsletterThumbName: "", // 썸네일이미지명
        newsletterThumbSize: "", // 썸네일이미지사이즈
        newsletterThumbDir: "", // 썸네일이미지위치
        attachList: [ // 첨부파일 리스트
            {
                fileName: "",
                fileSize: "",
                fileDir: "",
            }
        ]
    });

    const inputError = ref({
        title: '',
        content: '',
        newsletterThumbName: "", // 썸네일이미지명
    })

    const editorRef = ref(null)

    const retrieveNewsletterDetail = (id) => {
        loadingStore.loading = true;
        insightsNewsletterService.retrieveNewsletterDetail(id)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    newsletterDetail.value = result;
                    input.value.title = result.title;
                    input.value.content = result.content;
                    input.value.newsletterThumbName = result.newsletterThumbName;
                    input.value.newsletterThumbSize = result.newsletterThumbSize;
                    input.value.newsletterThumbDir = result.newsletterThumbDir;
                    input.value.attachList = result.attachList;

                    if(input.value.attachList.length === 0) {
                        input.value.attachList.push({
                            fileName: "",
                            fileSize: "",
                            fileDir: "",
                        })
                    }

                    setTimeout(()=>{
                        try {
                            editorRef.value.init(result.content)
                        } catch(e){}
                    }, 100)
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });
    };

    const uploadThumbFile = () => {
        const fileInput = document.createElement('input');
        fileInput.type= 'file';
        fileInput.accept = 'image/*';
        fileInput.click();

        fileInput.addEventListener('change', function(event){
            // console.log(event.target.files);
            const file = event.target.files[0];
            const fileSize = event.target.files[0].size;
            if(fileSize >= 1024 * 1024 * 200) {
                $alert('최대 200MB까지 첨부 가능합니다.');
                return;
            }

            let paramObj = {
                container: 'public',
                folder: 'newsletter',
                file,
            }
            fileService.uploadFile(paramObj)
                .then((res) => {
                    // console.log(res);
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        // console.log(result);
                        input.value.newsletterThumbName = result.originalFilename;
                        input.value.newsletterThumbSize = result.fileSize;
                        input.value.newsletterThumbDir = result.blobUrl;
                    }
                })
                .catch( (error) =>  {
                    console.log(error);
                });
        });
    }

    const removeThumbFile = () => {
        input.value.newsletterThumbName = '';
        input.value.newsletterThumbSize = '';
        input.value.newsletterThumbDir = '';
    };

    const addAttachment = () => {
        if(input.value.attachList.length >= 4) {
            $alert("첨부파일은 최대 4개까지 등록할 수 있습니다.");
            return;
        }

        input.value.attachList.push({
            fileName: "",
            fileSize: "",
            fileDir: "",
        });
    };

    const uploadAttachFile = (index) => {
        const fileInput = document.createElement('input');
        fileInput.type= 'file';
        fileInput.click();

        fileInput.addEventListener('change', function(event){
            // console.log(event.target.files);
            const file = event.target.files[0];
            const fileSize = event.target.files[0].size;
            if(fileSize >= 1024 * 1024 * 200) {
                $alert('최대 200MB까지 첨부 가능합니다.');
                return;
            }

            let paramObj = {
                container: 'public',
                folder: 'newsletterAttach',
                file,
            }
            fileService.uploadFile(paramObj)
                .then((res) => {
                    // console.log(res);
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        // console.log(result);
                        input.value.attachList[index].fileName = result.originalFilename;
                        input.value.attachList[index].fileSize = result.fileSize;
                        input.value.attachList[index].fileDir = result.blobUrl;
                    }
                })
                .catch( (error) =>  {
                    console.log(error);
                });
        });
    };

    const removeAttachFile = (index) => {
          if(input.value.attachList.length === 1) {
            input.value.attachList = [
                {
                    fileName: "",
                    fileSize: "",
                    fileDir: "",
                }
            ];
            return;
        }
        input.value.attachList.splice(index, 1);
    };

    const update = () => {
        const { title, content, newsletterThumbName, newsletterThumbSize, newsletterThumbDir, attachList } = input.value;
        let isInvalid = false;

        inputError.value = {
            title: '',
            content: '',
            newsletterThumbName: '',
        };

        if(!title) {
            inputError.value.title = '제목을 입력하세요.';
            isInvalid = true;
        } else if(title.length > 100) {
            inputError.value.title = "제목은 최대 100자까지 입력가능합니다.";
            isInvalid = true;
        }

        if(!content) {
            inputError.value.content = '내용을 입력하세요.';
            isInvalid = true;
        } else if(content.length > 2000) {
            inputError.value.content = "내용은 최대 2000자까지 입력가능합니다.";
            isInvalid = true;
        }

        if(!newsletterThumbName) {
            inputError.value.newsletterThumbName = '썸네일 이미지를 업로드하세요.';
            isInvalid = true;
        }

        if(!isInvalid) {
            let paramObj = {
                newsletterId: newsletterDetail.value.newsletterId,
                title,
                content: content.replace("<img ", "<img style=\"max-width:1200px; height:auto;\" "),
                newsletterThumbName,
                newsletterThumbSize,
                newsletterThumbDir,
                attachList: attachList.filter((attach) => attach.fileName && attach.fileDir),
            }

            loadingStore.loading = true;
            insightsNewsletterService.updateNewsletter(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        goBack()
                    } else {
                        $alert("저장을 실패하였습니다.");
                    }
                }).catch( (res) =>  {
                    loadingStore.loading = false;
                    // console.log(res);
                    $alert("저장을 실패하였습니다.");
                });
        }
    }

    const goBack = () => {
        router.push({ name: 'CSNewsletterDetail', params: {id: newsletterDetail.value.newsletterId}});
    };
</script>

<template>
    <div class="content">
        <div class="lecture-wrap">
            <div class="sub-title">
                <h3>뉴스레터 수정</h3>
                <p><span>*표시는 필수 입력사항</span>입니다.</p>
            </div>
            <div class="table-form">
                <table class="vertical">
                    <colgroup>
                        <col width="10%" />
                        <col />
                        <col />
                    </colgroup>
                    <tr>
                        <th><span class="mark">제목</span></th>
                        <td>
                            <KSAInput v-model="input.title" :msg="inputError.title" max-length="100" placeholder="제목을 입력하세요.(최대 100자 입력가능)"/>
                        </td>
                    </tr>
                    <tr>
                        <th><span class="mark">썸네일 이미지</span><br><span>(목록 출력)</span></th>
                        <td class="text-box">
                            <div class="grid file">
                                <KSAPrimaryButton text="파일 선택" @click="uploadThumbFile()" />
                                <KSAInput class="input icon" placeholder="파일 선택(333px X 471px 사이즈 이미지를 권장합니다.)" v-model="input.newsletterThumbName" disabled />
                                <button class="delete" :disabled="!input.newsletterThumbName" @click="removeThumbFile()"><i></i></button>
                            </div>
                            <small>최대 200MB 까지 첨부 가능</small>
                            <div>
                                <small style="color:#E71414;">{{ inputError.newsletterThumbName }}</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th><span class="mark">내용</span></th>
                        <td class="text-box">
                            <KSACKEditor ref="editorRef" v-model="input.content" />
                            <div style="display: flex; justify-content: space-between;">
                                <small style="color:#E71414;">{{ inputError.content }}</small>
                                <span><span :class="{'red': input.content.length > 2000}">{{ $number(input.content.length) }}</span>/2,000자</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th><span class="">첨부</span></th>
                        <td class="text-box">
                            <div class="grid file" v-for="(attach, index) in input.attachList">
                                <KSAPrimaryButton text="파일 선택" @click="uploadAttachFile(index)" />
                                <KSAInput class="input icon" placeholder="파일 선택" v-model="attach.fileName" disabled />
                                <button class="delete" :disabled="input.attachList.length === 1 && !attach.fileName" @click="removeAttachFile(index)"><i></i></button>
                            </div>
                            <small>최대 200MB 까지 첨부 가능</small>
                            <div>
                                <small style="color:#E71414;">{{ inputError.attachList }}</small>
                            </div>
                            <KSATextButton text="+ 파일 추가" @click="addAttachment()" :disabled="input.attachList.length >= 4"/>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="btn-wrap space-between">
                <KSASecondaryButton class="gray_button" text="취소" @click="goBack" />
                <KSAPrimaryButton text="수정" @click="update" :disabled="!input.title || !input.content || !input.newsletterThumbName" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    small {
        @include font-size_xs;
        color: $gray_color;
    }
    
    .file {
        margin-top: 5px;
    }
</style>